import React from "react";
import { Link } from "react-router-dom";
const Error404 = () => {
  return (
    <div className='jumbotron text-center p-8 h-100 w-100'>
      <h1 className='display-4'>404 ERROR!</h1>
      <p className='lead'>
        The page you are looking for is not found. It may have been moved or
        deleted.
      </p>
      <hr className='my-4' />
      <p>
        tuTrend is a non profit organization dedicated to providing free and
        quality education for all. To visit us on social media:
        <br />
        <Link to='/' className='  p-1  text-dark' href='#'>
          <i className='fab fa-twitter-square'></i>
        </Link>
        <Link to='/' className='p-1  text-dark' href='#'>
          <i className='fab fa-facebook '></i>
        </Link>
        <Link to='/' className='  p-1  text-dark' href='#'>
          <i className='fab fa-instagram-square '></i>
        </Link>
        <Link to='/' className='  p-1  text-dark' href='#'>
          <i className='fab fa-github '></i>
        </Link>
        <Link to='/' className='  p-1  text-dark' href='#'>
          <i className='fab fa-linkedin-in '></i>
        </Link>
      </p>
      <Link to='/' className='btn btn-primary btn-lg' href='#' role='button'>
        Back to Home
      </Link>
    </div>
  );
};

export default Error404;
